<template>
  <a
    :href="url"
    target="_blank"
    rel="noopener"
    tabindex="0"
    :aria-label="`${label} (${grupo})`"
    :title="`${label} (${grupo})`"
    role="button"
    :class="['action-btn', bgClass, 'text-white', 'mr-1', 'mb-1', 'd-inline-flex', 'align-items-center', 'shortcut-btn']"
    @click.stop
    @keydown.enter.prevent="openLink"
  >
    <i class="fas fa-external-link-alt mr-2" aria-hidden="true"></i>
    {{ label }}
    <span
      class="ml-2 text-white-50 pointer"
      title="Copiar link"
      aria-label="Copiar link"
      tabindex="0"
      role="button"
      @click.stop.prevent="copyUrl"
      @keydown.enter.prevent="copyUrl"
    >
      <i class="fas fa-copy"></i>
    </span>
  </a>
</template>

<script>
const tipoToLabel = {
  prod: 'PROD',
  test: 'TEST',
  branch: 'BRANCH',
  pwakraken: 'PWAKRAKEN',
  qrbeta: 'QRBETA',
  dashboard: 'DASHBOARD',
  servidor: 'SERVIDOR',
};
export default {
  name: 'ShortcutBtn',
  props: {
    url: { type: String, required: true },
    tipo: { type: String, required: true },
    grupo: { type: String, required: false },
  },
  computed: {
    label() {
      return tipoToLabel[this.tipo] || this.tipo;
    },
    bgClass() {
      if (this.tipo === 'prod') return 'bg-success';
      if (this.tipo === 'test') return 'bg-warning';
      if (this.tipo === 'branch') return 'bg-info';
      if (this.tipo === 'dashboard') return 'bg-primary';
      if (this.tipo === 'pwakraken' || this.tipo === 'qrbeta') return 'bg-primary';
      if (this.tipo === 'servidor') return 'bg-secondary';
      return 'bg-secondary';
    },
  },
  methods: {
    copyUrl(e) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.url);
        this.$emit('copied');
      }
    },
    openLink() {
      window.open(this.url, '_blank');
    },
  },
};
</script>

<style scoped>
.shortcut-btn {
  min-width: 90px;
  min-height: 2.5rem;
  font-size: 1.08em;
  padding: 0.6em 1.2em;
  border-radius: 1.5rem;
  font-weight: 500;
  outline: none;
  border: none;
  box-shadow: var(--shadow-qs-xs);
  transition: background 0.2s;
}
.shortcut-btn:focus {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}
.shortcut-btn:active {
  filter: brightness(0.9);
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.067);
}
.pointer {
  cursor: pointer;
}
</style> 